<template>
    <div class="navigator d-flex justify-content-between">
        <div>
            <h2 v-if="getSelectedEventListReservations" class="mr-auto">
                <span>{{filterEventName}}</span>
                <span class="fs-smaller darker ml-2 pointer underlined" @click="removeEventFilter">All activities</span>
            </h2>
            <h2 v-else class="mr-auto">Reservations</h2>
        </div>

        <div class="d-flex align-items-center" v-if="!getSelectedEventListReservations">
            <v-select 
                class="mr-3 reservationMainFilter"  
                :options="viewOptions" 
                v-model="selectedFilters.selectedView" 
                label="name" 
                @input="viewOptionsChanged">
            </v-select>
            
            <i class="ico ico-calendar fs-large dark mr-3"></i>
            
            <date-picker-new
                :key="pickerKey"
                class="dateRangePicker"
                v-model="selectedFilters.dateRange"
                :range="true"
                :clearOutside="true"
                :showFromTo="false"
                @input="dateRangeChanged">
            </date-picker-new>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    import extendedVSelect from '@/extends/vue-select'
    import DatePicker from 'vue2-datepicker'
    import DatePickerNew from '@/tools/DatePicker'

    export default {
        data() {
            return {
                viewOptions: [
                    {
                        name: 'Departure date',
                        id: 1
                    },
                    {
                        name: 'Pickup date',
                        id: 2
                    },
                    {
                        name: 'Sales date',
                        id: 3
                    },
                ],
                datePickerShortcuts: [
                    {
                        text: 'Next 7 Days',
                        start: new Date(),
                        end: new Date(Date.now() + 3600 * 1000 * 24 * 7)
                    },
                    {
                        text: 'Next 30 days',
                        start: new Date(),
                        end: new Date(Date.now() + 3600 * 1000 * 24 * 30)
                    }
                ],
                selectedFilters:{
                    selectedView: {
                        name: 'Departure date',
                        id: 1
                    },
                    dateRange: [
                        moment().startOf('day').format('YYYY-MM-DD'),
                        moment().endOf('day').format('YYYY-MM-DD')
                    ]
                },
                pickerKey: 0,
            }
        },
        created() {
            this.sendFiltersToParent();
        },
        computed: {
            ...mapGetters([
                'getReservations',
                'getListTo',
                'getListFrom',
                'getSelectedEventListReservations'
            ]),
            filterEventName() {
                if (this.getSelectedEventListReservations) {
                    return this.getSelectedEventListReservations.nameAlias? this.getSelectedEventListReservations.nameAlias : this.getSelectedEventListReservations.product.name;
                } else {
                    return false;
                }
            },
        },
        methods: {
            ...mapActions([
                'updateDateRange',
                'openModal',
                'resetNewReservationSetup',
                'resetClonedReservation',
                'getEventFromId',
                'setSelectedEventListReservations',
                'setReservationListType',
                'setBulkSelectedIds',
            ]),
            viewOptionsChanged(e) {
                this.setReservationListType(e.id);
                if (e.id != 1) {
                    this.setSelectedEventListReservations(null);
                }
                this.sendFiltersToParent();
            },
            dateRangeChanged() {
                this.sendFiltersToParent()
                this.setBulkSelectedIds([])
            },
            sendFiltersToParent() {
                this.$emit('mainFilterChanged', this.selectedFilters);
            },
            removeEventFilter() {
                this.setSelectedEventListReservations(null);
                this.eventHub.$emit('clearReservationFilters');
            }
        },
        components: {
            vSelect: extendedVSelect,
            DatePicker,
            DatePickerNew
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/scss/_variables.scss';
    
    .reservationMainFilter {
        min-width: 170px;
    }

    .dateRangePicker {
        min-width: 250px;
    }
</style>



// WEBPACK FOOTER //
// Navigator.vue?72513d5a